import { bookmarkRecipeFunction } from 'services/firebase';

const bookmark = async (recipeID, bookmarked) => {
  await bookmarkRecipeFunction({ recipeID, bookmarked });
};

export default bookmark;
